/**
 * Persisted session for the in-house auth (replaces Auth0's token cache).
 * The access token is short-lived (1h); the refresh token is rotated on every
 * POST /auth/refresh and lives for 60 days.
 */

export interface StoredSession {
  accessToken: string;
  refreshToken: string;
}

const STORAGE_KEY = 'lovellect-dashboard-session';

export const loadStoredSession = (): StoredSession | null => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as StoredSession;
    return parsed?.accessToken && parsed?.refreshToken ? parsed : null;
  } catch {
    return null;
  }
};

export const saveStoredSession = (session: StoredSession): void => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearStoredSession = (): void => {
  window.localStorage.removeItem(STORAGE_KEY);
};
